// src/components/GuidelinesViewer.js
import React from "react";
import DopePDF from "../img/MarketPlace.pdf"; // Adjust path as needed

const GuidelinesViewer = () => {
  return (
    <div className="w-full h-screen">
      <iframe
        src={DopePDF}
        title="Guidelines"
        className="w-full h-full border-0"
      />
    </div>
  );
};

export default GuidelinesViewer;
